var map = {
	"./2024.02/data.yml": "d360",
	"./2024.03/data.yml": "640f",
	"./2024.04/data.yml": "69dc",
	"./2024.05/data.yml": "d351",
	"./2024.06/data.yml": "5321",
	"./2024.07/data.yml": "8982",
	"./2024.08/data.yml": "b8f8",
	"./2024.09/data.yml": "1de4",
	"./2024.10/data.yml": "23d8",
	"./2024.11/data.yml": "eb79",
	"./2024.12/data.yml": "9048",
	"./2024.13/data.yml": "ef59",
	"./brescia-2025-12-28/data.yml": "991a",
	"./brescia-2026-01-04/data.yml": "a5da",
	"./essen-2024.02/data.yml": "e07a",
	"./essen-2024.03/data.yml": "139d",
	"./essen-2024.04/data.yml": "759c",
	"./essen-2025.01/data.yml": "c9bd",
	"./essen-2025.02/data.yml": "0766",
	"./essen-2025.03/data.yml": "00df",
	"./essen-2025.04/data.yml": "a59d",
	"./essen-2025.05/data.yml": "0398",
	"./essen-2025.06/data.yml": "5aa1",
	"./essen-2025.07/data.yml": "7b06",
	"./essen-2025.08/data.yml": "9ce5",
	"./hamburg-2025.01/data.yml": "20ca",
	"./hamburg-2025.02/data.yml": "e092",
	"./hamburg-2025.03/data.yml": "9fc1",
	"./muenchen-2025.01/data.yml": "e0e5",
	"./muenchen-2025.02/data.yml": "54c6",
	"./muenchen-2025.03/data.yml": "04b9",
	"./muenchen-2025.04/data.yml": "02ca",
	"./muenchen-2025.05/data.yml": "e1fa",
	"./muenchen-2025.06/data.yml": "d3af",
	"./muenchen-2025.07/data.yml": "f903",
	"./muenchen-2025.08/data.yml": "c1e4",
	"./muenchen-2025.09/data.yml": "10ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd7b";